import RestClient from './RestClient';
import { Customer } from '../../models';
import * as _ from 'es-toolkit';

class Customers extends RestClient {
    constructor() {
        super({
            "model": Customer,
            "entryPoint": "customers",
            "resource": "customer",
            "resources": "customers",
            "id_field": "_id"
        });
    }
    list(params) {
        // remove empty filter values
        params = _.pickBy(params, _.identity);

        // stringify fields
        const fields = (params?.fields || this.model.getListingFields() || []).join(',');

        return this.GET('/customers/list', { ...params, fields })
            .then(response => response.json())
            .then(json => {
                if (json.customers)
                    return {
                        ...json,
                        customers: json.customers.map(c => new Customer(c))
                    };
            throw new Error(json.flash.error);
        });
    }
}
const CustomersApi = new Customers();

export default CustomersApi;
